import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalSearchComponent } from './global-search.component';
import { GlobalSearchRoutingModule } from './global-search-routing.module';
import { AutocompleteSearchBoxComponent } from './shared/components/autocomplete-search-box/autocomplete-search-box.component';
import { ControlsModule } from '../controls/controls.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchResultItemComponent } from './shared/components/search-result-item/search-result-item.component';
import { SearchResultListComponent } from './shared/components/search-result-list/search-result-list.component';
import { SearchRefinementPanelComponent } from './shared/components/search-refinement-panel/search-refinement-panel.component';
import { SearchRefinementComponent } from './shared/components/search-refinement/search-refinement.component';


@NgModule({
  declarations: [
    GlobalSearchComponent,
    AutocompleteSearchBoxComponent,
    SearchResultItemComponent,
    SearchResultListComponent,
    SearchRefinementPanelComponent,
    SearchRefinementComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    GlobalSearchRoutingModule,
    ControlsModule
  ],
  exports: [  
    AutocompleteSearchBoxComponent
  ]
})
export class GlobalSearchModule { }
